import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container, Card, Box, Modal, TextField, Button, Typography,
  List, ListItem, ListItemText, Divider, CircularProgress, Alert
} from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import axiosInstance from '../../Service/axiosInstance';

const EspaceClient = ({ setUser }) => {
  const navigate = useNavigate();

  const [espaceClient, setEspaceClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [newTelephone, setNewTelephone] = useState('');
  const [newNom, setNewNom] = useState('');
  const [newPrenom, setNewPrenom] = useState('');

  const getColor = (fait) => {
    if (fait === null) return 'orange';
    if (fait === true) return 'green';
    return 'red';
  };

useEffect(() => {
 const token = localStorage.getItem("token");
  axiosInstance.get('/yourtravelshop/user/details', {
   headers: {
            Authorization: `Bearer ${token}`
          }
  })
  .then((response) => {
    setEspaceClient(response.data);
    setLoading(false);
  })
  .catch((error) => {
    console.error("Erreur lors de la récupération des détails du client :", error);
      setError("Pas de connexion internet. Veuillez vérifier votre connexion.");

      setError("Impossible de charger les informations du client. Veuillez vous reconnecter.");
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      setLoading(false)
      navigate('/login');
    ;
  });
}, [navigate]);

  const handleOpenModal = () => {
    const { mail, telephone, nom, prenom } = espaceClient.client;
    setNewEmail(mail);
    setNewTelephone(telephone);
    setNewNom(nom);
    setNewPrenom(prenom);
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);

const handleSubmit = () => {
  const token = localStorage.getItem('token');

  const userInfoUpdateDTO = {
    mail: newEmail,
    telephone: newTelephone,
    nom: newNom,
    prenom: newPrenom,
  };

  axiosInstance
    .put('/yourtravelshop/userInfo/update', userInfoUpdateDTO, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }) 
    .then(() => {
      setEspaceClient((prevState) => ({
        ...prevState,
        client: {
          ...prevState.client,
          mail: newEmail,
          telephone: newTelephone,
          nom: newNom,
          prenom: newPrenom,
        },
      }));
      handleCloseModal();
      navigate("/espace-client");
    })
    .catch((error) => {
      console.error("Erreur lors de la mise jour des informations :", error);
      setError("Impossible de mettre a jour les informations.");
      localStorage.removeItem("token");
      localStorage.removeItem('user');
       navigate("/Login");
    });
};

  dayjs.locale('fr');

  if (loading) return <CircularProgress sx={{ display: 'block', margin: 'auto', mt: 5 }} />;
  if (error) return <Alert severity="error" sx={{ mt: 5, textAlign: 'center' }}>{error}</Alert>;
  if (!espaceClient) return <Alert severity="info" sx={{ mt: 5, textAlign: 'center' }}>Aucune donnee disponible.</Alert>;

  const naissanceArray = espaceClient.client.dateNaissance;
  const creationArray = espaceClient.client.dateCreation;

  const dateNaissance = dayjs(new Date(naissanceArray[0], naissanceArray[1] - 1, naissanceArray[2]));
  const dateCreation = dayjs(new Date(creationArray[0], creationArray[1] - 1, creationArray[2]));

 
   return (
<div>

     <div className="trending" style = {{marginTop: "-100px"}}>
     <div className="espaceclient">
       <Container sx={{ mt: 5 }}>
       <Card sx={{
   p: 3,
   mb: 3,
   borderRadius: 2,
   boxShadow: 2,
   backgroundColor: '#f9f9f9',
   transition: 'transform 0.3s ease-in-out',
   '&:hover': {
     transform: 'scale(1.03)',
   },
   display: 'flex',          // Ajouter display flex ici
   flexDirection: 'column',  // S'assurer que les éléments sont empilés en colonne
 }}>
<div style={{ textAlign: "right" }}>
  <Typography variant="h5" gutterBottom color="primary">
<h4 style={{
          fontFamily: 'Beyond',
          fontSize: '20px',
          color: '#000000',
        }}>
     Espace client :        </h4>

    
  </Typography>
</div>
   <Typography variant="h5" gutterBottom color="primary">
          {espaceClient.client.nom} {espaceClient.client.prenom}
   </Typography>
 <Typography>Pays d'origine : {espaceClient.client.selectedCountry.nom}</Typography>
   <Typography>Email : {espaceClient.client.mail}</Typography>
   <Typography>Téléphone : {espaceClient.client.telephone}</Typography>
  <Typography>
  Date de naissance : {dateNaissance.format('DD MMMM YYYY')}
</Typography>
<Typography>
  Date d'inscription : {dateCreation.format('DD MMMM YYYY')}
</Typography>
 
   {/* Bouton pour ouvrir le modal, aligné à droite */}
   <Box sx={{ alignSelf: 'flex-end', mt: 2 }}>
     <Button variant="contained" color="primary" onClick={handleOpenModal}>
       Modifier les informations
     </Button>
   </Box>
 </Card>
 
 
              {/* Modal pour modifier email et téléphone */}
              <Modal open={openModal} onClose={handleCloseModal}>
             <Box sx={{
               position: 'absolute',
               top: '50%',
               left: '50%',
               transform: 'translate(-50%, -50%)',
               bgcolor: 'background.paper',
               p: 3,
               borderRadius: 2,
               boxShadow: 24,
               width: 300
             }}>
               <Typography variant="h6" gutterBottom>Modifier les informations</Typography>
 
               <TextField
                 label="Nom"
                 fullWidth
                 value={newNom}
                 onChange={(e) => setNewNom(e.target.value)}
                 margin="normal"
               />
               <TextField
                 label="Prenom"
                 fullWidth
                 value={newPrenom}
                 onChange={(e) => setNewPrenom(e.target.value)}
                 margin="normal"
               />
               <TextField
                 label="Email"
                 fullWidth
                 value={newEmail}
                 onChange={(e) => setNewEmail(e.target.value)}
                 margin="normal"
               />
               <TextField
                 label="Téléphone"
                 fullWidth
                 value={newTelephone}
                 onChange={(e) => setNewTelephone(e.target.value)}
                 margin="normal"
               />
               <Button variant="contained" color="primary" onClick={handleSubmit} fullWidth>
                 Sauvegarder
               </Button>
             </Box>
           </Modal>
 
         <Card sx={{
           p: 3,
           mb: 3,
           borderRadius: 2,
           boxShadow: 2,
           backgroundColor: '#f9f9f9',
           transition: 'transform 0.3s ease-in-out',
           '&:hover': {
             transform: 'scale(1.03)',
           }
         }}>
           
           <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>Mes demandes de devis</Typography>
  <List>
   {espaceClient.demandes.length > 0 ? (
     espaceClient.demandes.map((demande, index) => (
       <React.Fragment key={demande.idDemandeReservation}>
         <ListItem
           sx={{
             backgroundColor: index % 2 === 0 ? '#f1f1f1' : 'transparent',
           }}
         >
           <ListItemText
             primary={`${demande.nomPackage} - ${demande.nombrePersonne} adulte(s) // ${demande.nombreEnfant} enfant(s) // ${demande.nombreBebe} bébé(s) //`}             
		secondary={
               <>
                 <Typography component="span" variant="body2">
                   Début : {dayjs(demande.dateDebut).format('DD MMM YYYY')} — Fin : {dayjs(demande.dateFin).format('DD MMM YYYY')}
                 </Typography>
                 <br />
                 <Typography style={{ color: getColor(demande.fait), marginTop: 4 }}>
                   État : {demande.fait === null ? "En attente" : demande.fait ? "Répondu" : "Rejeté"}
                 </Typography>
                 {demande.requete && (
                   <Typography>
                     Requête : {demande.requete}
                   </Typography>
                 )}
               </>
             }
           />
         </ListItem>
         {index < espaceClient.demandes.length - 1 && <Divider />}
       </React.Fragment>
     ))
   ) : (
     <Typography>Aucune demande de devis trouvée.</Typography>
   )}
 </List>
 
         </Card>
 
         <Card sx={{
           p: 3,
           borderRadius: 2,
           boxShadow: 2,
           backgroundColor: '#f9f9f9',
           transition: 'transform 0.3s ease-in-out',
           '&:hover': {
             transform: 'scale(1.03)',
           }
         }}>
           <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>Confirmations de Réservation</Typography>
           <List>
  {espaceClient.confirmations.length > 0 ? (
    espaceClient.confirmations.map((confirmation, index) => (
      <React.Fragment key={confirmation.idConfirmation}>
        <ListItem sx={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'transparent' }}>
          <ListItemText
            primary={`${confirmation.nomPackage} - ${confirmation.nombrePersonne} adulte(s) // ${confirmation.nombreEnfant} enfant(s) // ${confirmation.nombreBebe} bébé(s)`}
            secondary={
              <>
              <Typography
                  component="span"
                  variant="body2"
                  color="textSecondary"
                  sx={{ display: 'block', marginBottom: 2 }}
                >
                  Confirmé le : {dayjs(new Date(
                    confirmation.dateConfirmation[0],
                    confirmation.dateConfirmation[1] - 1,
                    confirmation.dateConfirmation[2],
                    confirmation.dateConfirmation[3],
                    confirmation.dateConfirmation[4],
                    confirmation.dateConfirmation[5]
                  )).format('DD MMMM YYYY à HH:mm')}
                </Typography>
                <Typography component="span" variant="body2" sx={{ display: 'block', marginBottom: 0.5 }}>
                <strong>Durée :</strong>
                {' du '}
                {dayjs(confirmation.dateDebutConf).format('D MMMM YYYY')}
                {' au '}
                {dayjs(confirmation.dateFinConf).format('D MMMM YYYY')}
              </Typography>

                <Typography component="span" variant="body2" sx={{ display: 'block', marginBottom: 0.5 }}>
                  <strong>Statut du paiement :</strong> 
                  <span style={{ color: confirmation.statutPaiement === 'paye' ? 'green' : 'red' }}>
                    {confirmation.statutPaiement}
                  </span>
                </Typography>

                <Typography component="span" variant="body2" sx={{ display: 'block', marginBottom: 0.5 }}>
                  <strong>Mode de paiement :</strong> {confirmation.nomModePaiement}
                </Typography>

                <Typography component="span" variant="body2" sx={{ display: 'block', marginBottom: 0.5 }}>
                  <strong>Montant total :</strong> {confirmation.montantTotal} Ar
                </Typography>

                <Typography component="span" variant="body2" sx={{ display: 'block', marginBottom: 0.5 }}>
                  <strong>Montant payé :</strong> {confirmation.montantPaye} Ar
                </Typography>

                <Typography component="span" variant="body2" sx={{ display: 'block', marginBottom: 0.5 }}>
                  <strong>Reste à payer :</strong> {confirmation.resteAPayer} Ar
                </Typography>

                <Typography component="span" variant="body2" sx={{ display: 'block', marginBottom: 2 }}>
                  <strong>Partiel payé :</strong> {confirmation.pourcentagePaye} %
                </Typography>
              </>
            }
          />
        </ListItem>
        {index < espaceClient.confirmations.length - 1 && <Divider />}
      </React.Fragment>
    ))
  ) : (
    <Typography sx={{ padding: 2 }}>Aucune confirmation de réservation trouvée.</Typography>
  )}
</List>

         </Card>
       </Container>
       </div>
     </div>
</div>
   );
 };
 
 export default EspaceClient;